import Can from "../../util/can";
import { Menu } from "antd";
import { PropTypes } from "prop-types";
import React from "react";

const PermissionMenu = (props) => {
  const { resource, children } = props;
  // const { authUser } = useSelector(({ auth }) => auth);

  // Check to make sure that PSP user has minimal functionality
  // if (authUser && authUser.role.name === "PSP") {
  //   if(resource === SETTLEMENT_REPORTS ||
  //     resource === TRANSACTION_SETTLEMENTS ||
  //     resource === PROCESSING_SUMMARIES ||
  //     resource === MERCHANT_ACCOUNTS ||
  //     resource === PERMISSIONS ||
  //     resource === USERS ||
  //     resource === ROLES ||
  //     resource === PERMISSIONS ||
  //     resource === TRANSACTION_CHARGES) {
  //     return <Can I="read" a=""></Can>;
  //   }
  // } else if(authUser && authUser.role.name === "BUSINESS") {
  //   if(resource === SETTLEMENT_REPORTS ||
  //     resource === TRANSACTION_SETTLEMENTS ||
  //     resource === PROCESSING_SUMMARIES ||
  //     resource === PERMISSIONS ||
  //     resource === USERS ||
  //     resource === ROLES ||
  //     resource === PERMISSIONS ||
  //     resource === TRANSACTION_CHARGES) {
  //     return <Can I="read" a=""></Can>;
  //   }
  // } else if(authUser && authUser.role.name === "AFFILIATE") {
  //   if(resource === SETTLEMENT_REPORTS ||
  //     resource === TRANSACTION_SETTLEMENTS ||
  //     resource === PROCESSING_SUMMARIES ||
  //     resource === PERMISSIONS ||
  //     resource === USERS ||
  //     resource === ROLES ||
  //     resource === PERMISSIONS ||
  //     resource === TRANSACTION_CHARGES) {
  //     return <Can I="read" a=""></Can>;
  //   }
  // }

  return (
    <Can I="read" a={resource}>
      <Menu.Item {...props}>
        {children}
      </Menu.Item>
    </Can>
  );
};

PermissionMenu.defaultProps = {
  resource: '',
};

PermissionMenu.propTypes = {
  resource: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PermissionMenu;
